import { api } from 'app/config/apiConfig';
import { ReceiptDocument } from '../model/types';

export interface ReceiptUrlResponse {
  url: string;
}

export const receiptApi = api.injectEndpoints({
  endpoints: (build) => ({
    getReceiptsByPaymentId: build.query<ReceiptDocument[], string>({
      query: (paymentId) => ({
        url: `/billing-documents/payments/${paymentId}/receipts`,
        method: 'GET',
      }),
      providesTags: ['Receipts'],
    }),

    getReceiptsByContractId: build.query<ReceiptDocument[], string>({
      query: (contractId) => ({
        url: `/billing-documents/contracts/${contractId}/receipts`,
        method: 'GET',
      }),
      providesTags: ['Receipts'],
    }),

    getReceiptUrl: build.query<ReceiptUrlResponse, string>({
      query: (paymentId) => ({
        url: `/billing-documents/payments/${paymentId}/receipt-url`,
        method: 'GET',
      }),
    }),
    issueReceipt: build.mutation<ReceiptDocument, { paymentId: string }>({
      query: ({ paymentId }) => ({
        url: `/billing-documents/payments/${paymentId}/receipts`,
        method: 'POST',
      }),
      invalidatesTags: ['Receipts', 'Invoices', 'Contract details'],
    }),
  }),
});

export const {
  useGetReceiptsByPaymentIdQuery,
  useLazyGetReceiptsByPaymentIdQuery,
  useGetReceiptsByContractIdQuery,
  useLazyGetReceiptsByContractIdQuery,
  useGetReceiptUrlQuery,
  useLazyGetReceiptUrlQuery,
  useIssueReceiptMutation,
} = receiptApi;
